import { Controller } from '@hotwired/stimulus'
import { scrollIntoViewUnlessIframe } from '../helpers/scroll_into_view_unless_iframe'

export default class extends Controller {
  WAITING_STEP = 1200
  FINAL_WAITING_STEP = 2800

  static targets = ['loadingItem', 'toggleBusyItem', 'editableItem', 'editableItems']

  static values = {
    customDelay: Number,
    redirectUrl: String, // Because we might have a custom redirect for "qualification" page.
    frameId: String,
  }

  static classes = ['slideInFromBottomAnimation']

  connect () {
    this.interval = window.setInterval(() => {
      const firstLoadingItem = this.loadingItemTargets.find((loadingItem) => loadingItem.getAttribute('aria-busy') === 'true')

      if (firstLoadingItem) {
        if (this.hasEditableItemsTarget && this.isLastLoadingItem(firstLoadingItem)) {
          firstLoadingItem.classList.add(this.slideInFromBottomAnimationClass)
          this.editableItemTargets.forEach((editableItem) => {
            editableItem.setAttribute('hidden', true)
          })
        }
        firstLoadingItem.removeAttribute('aria-busy')

        scrollIntoViewUnlessIframe(firstLoadingItem, { behavior: 'smooth', block: 'center' })
      } else {
        window.clearInterval(this.interval)
        if (!this.hasEditableItemsTarget && this.redirectUrlValue) {
          return Turbo.visit(
            this.redirectUrlValue, {
              frame: this.frameIdValue,
              action: "replace"
            }
          )
        }
        window.setTimeout(() => {
          if (this.loadingItemTargets[0]) {
            scrollIntoViewUnlessIframe(this.loadingItemTargets[0])
          }
          this.toggleBusyItemTargets.forEach((toggleBusyItem) => {
            toggleBusyItem.setAttribute('aria-busy', 'false')
          })
        }, this.customDelayValue || this.FINAL_WAITING_STEP)
      }
    }, this.customDelayValue || this.WAITING_STEP)
  }

  isLastLoadingItem(loadingItem) {
    return loadingItem === this.loadingItemTargets[this.loadingItemTargets.length - 1]
  }
}
